import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SiteLayout from "@/components/SiteLayout";
import PageMeta from "@/components/PageMeta";
import { api } from "@/lib/api";

export default function ExpertiseIndex() {
  const [areas, setAreas] = useState([]);
  useEffect(() => { api.get("/departments").then((r) => setAreas(r.data)); }, []);
  return (
    <SiteLayout>
      <PageMeta
        title="Services | Carlton Elleker Chase"
        description="A full-service London law firm with particular expertise in media, finance, technology and property. Five departments, considered counsel."
      />
      <section className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 pt-10 md:pt-20" data-testid="expertise-page">
        <h1 className="h-display text-[clamp(2.4rem,7vw,6rem)] max-w-[20ch]">
          What we do.
        </h1>
        <div className="mt-10 max-w-3xl space-y-6 text-base md:text-lg text-graphite/85 leading-relaxed">
          <p>
            <strong className="font-semibold">Carlton Elleker Chase</strong> is a full-service
            law firm with particular expertise in the media, finance, technology and property
            sectors. We are commercial lawyers who act as trusted advisors to individuals and
            businesses — ranging all the way from start-ups to PLC listing.
          </p>
          <p>
            The firm is structured around five departments: Company &amp; Commercial, Dispute
            Resolution, Financial Services, Property and IP &amp; IT. Each department offers
            in-detailed sector knowledge and specialisms. With experts in each of these areas
            we are well placed to help you with your requirements.
          </p>
        </div>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-24">
        <ul className="hairline-top" data-testid="expertise-page-list">
          {areas.map((a, i) => (
            <li key={a.slug} className="num-list-row hairline-bottom">
              <Link to={`/expertise/${a.slug}`} className="grid grid-cols-12 gap-4 md:gap-8 py-10 md:py-14 items-start" data-testid={`expertise-link-${a.slug}`}>
                <span className="col-span-2 md:col-span-1 text-xs text-graphite/55 pt-2">{String(i + 1).padStart(2, "0")}</span>
                <div className="col-span-10 md:col-span-8">
                  <h2 className="num-title text-[clamp(1.8rem,3.2vw,3rem)] font-semibold tracking-tight">{a.title}</h2>
                  <p className="mt-3 text-graphite/75 max-w-2xl leading-relaxed">{a.tagline}</p>
                  <p className="mt-3 text-xs text-graphite/55">
                    {a.service_count} services {a.head_lawyer && <>· Head: {a.head_lawyer.name}</>}
                  </p>
                </div>
                <div className="hidden md:flex md:col-span-3 justify-end num-arrow pt-3">
                  <ArrowUpRight size={28} className="text-[#1E3668]" />
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </SiteLayout>
  );
}
